import React from "react";

interface IProps {
    title: string,
    value: string,
    placeholder?: string,
    disabled?: boolean,
    onChangeText?: (text: string) => void,
    errMsg?: string
}

function Form(props: IProps) {
    const {title, placeholder, onChangeText, value, disabled = false, errMsg = ""} = props

    const $errMsg = errMsg.length ? <p className="text-red-500 text-sm italic">{errMsg}</p> : null
    const $title = title.length ? <p className={"relative text-gray-1 text-sm text-left"}>{title}</p> : null
    return (
        <div>
            {$title}
            <input disabled={disabled} value={value} placeholder={placeholder} onChange={(e) => {
                onChangeText && onChangeText(e.target.value)
            }} className={`form-text text-sm ${disabled ? "text-gray-3" : ""} w-full py-2 px-4 bg-gray-6 h-10 rounded-md focus:outline-none border mt-1 ${errMsg && errMsg.length ? "bg-error-20 border border-error focus:border-error" : "border border-transparent focus:border-theme-blue focus:ring-4 focus:ring-color-theme "}`} />
            {$errMsg}
        </div>
    )
}

export default Form
